import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'

export const ScrollContainer = styled.div`
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 12px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${Colors.Neutral20};
    border: 4px solid ${Colors.White};
    border-radius: 6px;

    &:hover {
      background-color: ${Colors.Neutral30};
    }
  }
`

export const hideScrollMixin = css`
  overflow-y: auto;
  scrollbar-width: none; /* For Firefox */

  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
`

export const ScrollContainerWithHiddenScrollbar = styled.div`
  ${hideScrollMixin}
`
